import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSpring = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.106 12.412c0-1.608 1.273-2.948 2.887-2.948s2.888 1.34 2.888 2.948c0 1.609-1.273 2.948-2.888 2.948s-2.887-1.34-2.887-2.948m1.5 0c0-.82.64-1.448 1.387-1.448s1.388.629 1.388 1.448c0 .82-.64 1.448-1.388 1.448-.746 0-1.387-.628-1.387-1.448"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.994 2a4.36 4.36 0 0 0-3.14 1.344 4.62 4.62 0 0 0-1.283 3.029 4.28 4.28 0 0 0-3.172.332A4.4 4.4 0 0 0 3.05 7.802a4.6 4.6 0 0 0-.835 1.538 4.65 4.65 0 0 0 .257 3.44c.26.528.618 1 1.056 1.39.394.349.847.624 1.335.812-.285.44-.493.929-.613 1.443a4.63 4.63 0 0 0 .527 3.41c.302.505.699.945 1.169 1.293a4.34 4.34 0 0 0 3.295.817 4.41 4.41 0 0 0 2.76-1.632 4.41 4.41 0 0 0 2.759 1.632 4.35 4.35 0 0 0 3.296-.817c.47-.348.867-.788 1.169-1.293a4.625 4.625 0 0 0 .527-3.41 4.6 4.6 0 0 0-.616-1.447 4.4 4.4 0 0 0 1.324-.798c.44-.386.8-.857 1.062-1.386a4.636 4.636 0 0 0 .264-3.44l-.054-.16.054.16-.054-.16a4.6 4.6 0 0 0-.82-1.422 4.4 4.4 0 0 0-1.318-1.055 4.3 4.3 0 0 0-3.177-.33 4.62 4.62 0 0 0-1.284-3.043A4.36 4.36 0 0 0 11.993 2m.709 16.513q.14.407.386.752a2.92 2.92 0 0 0 1.91 1.2 2.85 2.85 0 0 0 2.16-.54l.003-.002c.31-.229.573-.52.775-.858a3.125 3.125 0 0 0 .354-2.298 3.1 3.1 0 0 0-.477-1.067 3.6 3.6 0 0 0-.585-.616.75.75 0 0 1 .442-1.326q.419-.02.821-.142c.357-.12.69-.31.979-.564.29-.255.531-.568.707-.923s.282-.743.313-1.143c-.008-1.01-.296-1.654-.44-1.85a2.96 2.96 0 0 0-1.153-1.09 2.8 2.8 0 0 0-2.233-.166 2.5 2.5 0 0 0-.711.34.75.75 0 0 1-1.15-.812c.075-.278.114-.566.116-.855 0-.817-.315-1.597-.866-2.167a2.86 2.86 0 0 0-2.06-.886c-.768 0-1.51.315-2.06.886a3.13 3.13 0 0 0-.867 2.167q.003.437.116.855a.75.75 0 0 1-1.158.806 2.5 2.5 0 0 0-.732-.357 2.78 2.78 0 0 0-2.196.176 2.9 2.9 0 0 0-.891.725c-.25.302-.44.652-.56 1.033a3.15 3.15 0 0 0 .173 2.328c.174.356.414.67.704.928.287.255.618.447.974.57q.407.12.83.141a.75.75 0 0 1 .445 1.326q-.327.271-.584.616c-.225.319-.387.68-.478 1.067a3.13 3.13 0 0 0 .354 2.298c.202.338.466.63.775.858l.003.003c.628.469 1.404.66 2.161.538a2.92 2.92 0 0 0 1.907-1.196q.238-.344.371-.748a.75.75 0 0 1 1.422-.008"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSpring;
